import React, { useEffect, useState } from "react";
import SectionTitleAndDescription from "./SectionTitleAndDescription";
import Label from "components/Common/Label/Label";
import GoogleLocationWithDropdown from "components/Common/SearchableDropdown/GoogleLocationWithDropdown";
import {
  addExcludeLocation,
  removeExcludeLocation,
  updateLocationRadius,
  resetExcludeLocations,
} from "store/slices/searcSlice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/store";
import { SvgIcons } from "Icon/SvgIcons";
import { useAppSelector } from "hooks/reduxHooks";

interface AddExcludeLocationProps {
  isModal?: boolean;
  searchId?: string | null;
}
const ExcludeLocationComponent: React.FC<AddExcludeLocationProps> = ({ isModal, searchId }) => {
  const dispatch = useDispatch();
  const excludedLocations = useSelector((state: RootState) => state.search.exclude_locations);
  const locationRadius = useSelector((state: RootState) => state.search.location_radius);
  const selectedProject = useAppSelector((state: any) => state.search?.selectedProjectFromSearch);

  const [location, setLocation] = useState<string | null>(null);

  const [locationWithRadius, setLocationWithRadius] = useState<any>([]);

  const [isLocationDeleted, setIsLocationDeleted] = useState<boolean>(false);

  const handleCityChange = (selected: string[] | string) => {
    const lastSelectedValue = Array.isArray(selected) ? selected[selected.length - 1] : selected;
    setLocation(lastSelectedValue);
    dispatch(addExcludeLocation(lastSelectedValue));
  };

  const handleRadiusChange = (value: any) => {
    const radiusValue = parseInt(value, 10) || 0;
    dispatch(updateLocationRadius(radiusValue));
  };

  const handleSave = async () => {
    if (location) {
      dispatch(addExcludeLocation(location));
      setLocation(null);
    }
  };
  const handleDelete = (locationToDelete: { city: string; radius: number }) => {
    setIsLocationDeleted(true);
    console.log("City to be deleted : ", locationToDelete.city);
    // Filter out the object with the matching location
    setLocationWithRadius((prevState: any[]) =>
      prevState.filter((item) => item.location !== locationToDelete.city)
    );
    dispatch(removeExcludeLocation(locationToDelete.city));
  };

  useEffect(() => {
    if (selectedProject && !isModal && !searchId) {
      dispatch(resetExcludeLocations());
      const locations_excluded = selectedProject.locations_excluded || [];
      dispatch(addExcludeLocation(locations_excluded));
    }
  }, [selectedProject]);

  useEffect(() => {
    if (!isLocationDeleted) {
      setLocationWithRadius((prevState: any[]) => {
        const newLocations = excludedLocations.filter(
          (value: string) => !prevState.some((item) => item.location === value)
        );

        return [
          ...prevState,
          ...newLocations.map((value: string, index: number) => ({
            location: value,
            radius: 0,
            key: prevState.length + index, // Ensures unique keys
          })),
        ];
      });
    } else {
      setIsLocationDeleted(false);
    }
  }, [excludedLocations]);

  return (
    <>
      <div className="w-1/4">
        <SectionTitleAndDescription
          title="Exclude Location"
          isRequiredSection={false}
          isHelpInfoReq={false}
          description="Select locations to exclude."
        />
      </div>

      <div className="w-3/4">
        <div className="xl:flex grid gap-4 items-center">
          <div className="xl:w-7/12	w-full">
            <Label labelTitle={"Select Location(s)"} isHelpIconRequired={false} />
            <div className="mt-1.5 SelectProject-input">
              <GoogleLocationWithDropdown
                handleChange={handleCityChange}
                selectedLocations={null}
                placeholder={"Search for a location..."}
                allLocations={excludedLocations}
              />
            </div>
          </div>

          <p className="font-normal text-xs text-text-tertiary xl:text-inherit text-center  relative top-2.5 left-1">
            - AND -
          </p>

          <div className="xl:w-3/12	w-full">
            <Label labelTitle={"Select Radius (mile)"} isHelpIconRequired={false} />
            <input
              type="number"
              className="border-primary-border border border-solid py-2.5	 px-3.5 shadow-sm rounded-md text-sm outline-none focus:border-primary w-full mt-1.5"
              // value={locationRadius}
              value={locationRadius}
              onChange={(e) => handleRadiusChange(e.target.value)}
              min={0}
              placeholder="0"
            />
          </div>
          <span className="self-end mb-3 w-5 h-5"></span>
        </div>
        {/* <button
          className={`flex-1 text-sm font-normal mt-2 underline  ${
            location ? "text-primary cursor-pointer" : "text-secondary-border cursor-not-allowed"
          }`}
          onClick={handleSave}
          disabled={location ? false : true}
        >
          Add Location
        </button> */}

        {locationWithRadius.length > 0 && (
          <div className="my-3">
            {locationWithRadius
              .slice()
              .reverse()
              .map((item: any) => (
                <div className="xl:flex grid gap-4 items-center my-2" key={item.key}>
                  <div className="xl:w-7/12 w-full">
                    <Label labelTitle={"City"} isHelpIconRequired={false} />
                    <div className="mt-1.5 SelectProject-input">
                      <GoogleLocationWithDropdown
                        selectedLocations={item.location}
                        placeholder={"Search for a location..."}
                        disabled={true}
                      />
                    </div>
                  </div>

                  <p className="font-normal text-xs text-text-tertiary xl:text-inherit text-center relative top-2.5 left-1">
                    - AND -
                  </p>

                  <div className="xl:w-3/12 w-full">
                    <Label labelTitle={"Radius (mile)"} isHelpIconRequired={false} />
                    <input
                      type="number"
                      min={0}
                     onChange={(e) => handleRadiusChange(e.target.value)}
                      value={locationRadius}
                      className="border-primary-border border border-solid py-2.5 px-3.5 shadow-sm rounded-md text-sm outline-none focus:border-primary w-full mt-1.5"
                      placeholder="0"
                    />
                  </div>
                  <span
                    className="cursor-pointer text-red-600 self-end mb-3"
                    onClick={() => handleDelete({ city: item.location, radius: item.radius })}
                  >
                    {SvgIcons.deleteSvg}
                  </span>
                </div>
              ))}
          </div>
        )}
      </div>
    </>
  );
};

export default ExcludeLocationComponent;
